module.exports = __webpack_public_path__ + "static/media/30s_female_actors_temp.4cc07c9c.jpg";